module.exports = __webpack_public_path__ + "static/media/kv.0a497b83.png";